var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainPage",on:{"click":_vm.loginOut}},[_vm._v("退出登录")])
}
var staticRenderFns = []

export { render, staticRenderFns }